import React, { useEffect, useState, createContext } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useLocation } from "react-router-dom";
import SessionsApi from "../../Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq6 from "Classes/Models/Requests/SearchStringOrIntReq";

import SingleSessions from "./SingleSessions";
import Packages from "./Packages";
import PackageGroups from "./PackageGroups";
import SwitchTabButtons from "./SwitchTabButtons";
import { useContext } from "react";
import { UserContext } from "App";
const index = () => {
  const User = useContext(UserContext);

  const { state } = useLocation();
  const [IsLoaded, setIsLoaded] = useState(false);
  const [TabSwitcher, setTabSwitcher] = useState("SingleSessions");
  // let req = SearchStringOrIntReq5

  const ShowTab = () => {
    if (TabSwitcher == "SingleSessions") {
      return <SingleSessions CurrentUser={User} />;
    }
    if (TabSwitcher == "Packages") {
      return <Packages />;
    }
    if (TabSwitcher == "PackageGroups") {
      return <PackageGroups />;
    }
  };

  useEffect(() => {
    if (!User) {
      setIsLoaded(false);
    } else {
      setIsLoaded(true);
    }
  }, [User]);

  if (IsLoaded == false) {
    return <div>Loading...</div>;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {(User.userType == "Therapist" ||
        User.userType == "FloorManager" ||
        User.userType == "Patient" ||
        User.userType == "AppointmentEmployee" ||
        User.userType == "CallCenterEmployee") && (
        <SingleSessions CurrentUser={User} />
      )}

      {(["Admin", "Owner", "HeadAccounting"].includes(User.userType) || User.userType == "AccountingEmployee") && (
        <>
          {/* <SwitchTabButtons setTabSwitcher={setTabSwitcher} /> */}
          {ShowTab()}
        </>
      )}
    </DashboardLayout>
  );
};

export default index;
